// - npm packages
import { useEffect } from "react";
import { isFirefox } from "react-device-detect";

// - utils, redux, config, constant and others
import appDetails from "../../../package.json";
// import mixManifest from "../../../public/mix-manifest.json";
import { isDevelopment } from "../utility/is";

const useCache = () => {
    useEffect(() => {
        const localVersion = localStorage.getItem("version");
        // uncomment this later
        // const version = !isDevelopment()
        //     ? mixManifest["/js/app.js"].split("?id=")[1] || appDetails.version
        //     : appDetails.version;
        const version = appDetails.version;
        if (version != localVersion) {
            if ("caches" in window) {
                caches.keys().then((names) => {
                    names.forEach((name) => {
                        caches.delete(name);
                    });
                });
            }

            if (!isFirefox && "indexedDB" in window) {
                indexedDB.databases().then((dbs) => {
                    dbs.forEach((db) => indexedDB.deleteDatabase(db.name));
                });
            }

            if (window?.navigator && navigator?.serviceWorker) {
                navigator.serviceWorker
                    .getRegistrations()
                    .then((registrations) => {
                        for (let registration of registrations) {
                            registration.unregister();
                        }
                    });
            }

            sessionStorage.clear();
            // localStorage.clear();
            localStorage.setItem("version", version);

            window.location.reload(true);
        }
    }, []);

    return {};
};

export default useCache;
